<span class="label">
    {{displayName}}
</span>
<mat-icon [class.descending]="isDescending"
          [class.selected]="isSelected"
          class="icon"
          color="accent">
    sort
</mat-icon>
